
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 14.89h1.63l.973-2.177h3.918l.986 2.177h1.63L6.562 5 2 14.89zm3.234-3.568l1.328-2.947 1.328 2.947H5.234zm11.32 3.568H18V8.003h-1.446v.592c-.487-.455-1.144-.702-1.854-.702-1.933 0-3.287 1.597-3.287 3.553S12.767 15 14.7 15c.71 0 1.367-.234 1.854-.689v.579zm-1.71-1.295c-1.17 0-1.958-.95-1.958-2.149 0-1.198.789-2.148 1.959-2.148.775 0 1.367.371 1.709.922v2.466c-.342.537-.934.909-1.71.909z","fill":"#303133"}})])
          )
        }
      }
    